import React, { useState, useEffect, useRef, useCallback, useMemo } from "react";

import TreeView from "devextreme-react/tree-view";
import { navigation } from "../../app-navigation";
import { useNavigation } from "../../contexts/navigation";
import { useScreenSize } from "../../utils/media-query";
import "./side-navigation-menu.scss";
import { useAuth } from "../../contexts/auth";

import * as events from "devextreme/events";

// Helper function to determine which form version to use
function getFormVersion(userDefaultFormView) {
  const localPref = localStorage.getItem("use_new_form");
  if (localPref !== null) {
    return localPref === "true";
  }
  return userDefaultFormView === 1;
}

export default function (props) {
  const { user, signOut } = useAuth();
  const { children, selectedItemChanged, openMenu, compactMode, onMenuReady } =
    props;

  const { isLarge } = useScreenSize();

  // State to trigger re-render when toggle changes
  const [toggleTrigger, setToggleTrigger] = useState(0);

  // Sync with header toggle button
  useEffect(() => {
    const onStorage = (e) => {
      if (e.key === "use_new_form") {
        setToggleTrigger(prev => prev + 1); // Force re-render
      }
    };
    window.addEventListener("storage", onStorage);
    return () => window.removeEventListener("storage", onStorage);
  }, []);

  function normalizePath() {
    const useNewVersion = getFormVersion(user?.defaultFormView);
    const formRoute = useNewVersion ? "form" : "test-form";

    let navigation = [
      {
        text: "בית",
        path: "/home",
        icon: "home",
      },
    {
      text: "מסמכים לטיפולי",
      path: "/tasks",
      icon: "bulletlist",
    },
    {
      text: "טיוטות",
      path: "/drafts",
      icon: "doc",
    },
    {
      text: "תבניות",
      path: "/templates",
      icon: "repeat",
    }
    ];
    //set array members from user's data
    user.form.listOfForms.map((item) => {
      let url = item.ID;

      navigation.push({
        text: item.FormName,
        path: `/${formRoute}?f=${url}`,
        icon: "edit",
      });
    });
    //return the items
    return navigation.map((item) => {
      if (item.path && !/^\//.test(item.path)) {
        item.path = `/${item.path}`;
      }
      return { ...item, expanded: isLarge };
    });
  }

  const items = useMemo(
    normalizePath,
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [toggleTrigger, user?.defaultFormView]
  );

  const {
    navigationData: { currentPath },
  } = useNavigation();

  const treeViewRef = useRef();
  const wrapperRef = useRef();
  const getWrapperRef = useCallback(
    (element) => {
      const prevElement = wrapperRef.current;
      if (prevElement) {
        events.off(prevElement, "dxclick");
      }

      wrapperRef.current = element;
      events.on(element, "dxclick", (e) => {
        openMenu(e);
      });
    },
    [openMenu]
  );

  useEffect(() => {
    const treeView = treeViewRef.current && treeViewRef.current.instance;
    if (!treeView) {
      return;
    }

    if (currentPath !== undefined) {
      treeView.selectItem(currentPath);
      treeView.expandItem(currentPath);
    }

    if (compactMode) {
      treeView.collapseAll();
    }
  }, [currentPath, compactMode]);

  return (
    <div
      className={"dx-swatch-additional side-navigation-menu"}
      ref={getWrapperRef}
    >
      {children}
      <div className={"menu-container"}>
        <TreeView
          ref={treeViewRef}
          items={items}
          keyExpr={"text"}
          selectionMode={"single"}
          focusStateEnabled={false}
          expandEvent={"click"}
          onItemClick={selectedItemChanged}
          onContentReady={onMenuReady}
          width={"100%"}
        />
      </div>
    </div>
  );
}
